import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getBoostsHandler, { ILibBoost, IUserBoost } from "./get-boosts.handler";
import buyBoostHandler from "./buy-boost.handler";

export interface IBoostsState extends IRequestState {
    userBoosts: IUserBoost[];
    lib: ILibBoost[],
};

const initialState: IBoostsState = {
    userBoosts: [],
    lib: [],

    loading: false,
    error: "",
};

const boostsSlice = createSlice({
    name: 'boosts',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<IBoostsState>) => {
        getBoostsHandler(builder);
        buyBoostHandler(builder);
    },
});

export default boostsSlice.reducer;